import React from 'react';
import SplitSection from '../common/split-section';
import PromiseCardsSection from '../promise-cards-section';
import { COMMITTED_TO_SECURITY_DATA, DATA_SECURITY_CARDS } from './constants';

const CommittedToSecuritySection: React.FC = () => {
  return (
    <section className="py-8 xl:py-24 lg:py-24 md:py-24 wg-container">
      <SplitSection
        heading={COMMITTED_TO_SECURITY_DATA.heading}
        headingClasses="w-5/12 pr-16 md:pr-0 sm:w-full sm:pr-0"
        classname="flex justify-between items-start sm:flex-col"
        description={COMMITTED_TO_SECURITY_DATA.description}
        child={
          <div className="flex justify-end w-7/12 items-center sm:w-full">
            <picture>
              <source
                className="w-full"
                type="image/webp"
                srcSet={COMMITTED_TO_SECURITY_DATA.image.webp}
              />
              <source
                className="w-full"
                type="image/jpeg"
                srcSet={COMMITTED_TO_SECURITY_DATA.image.jpeg}
              />
              <img
                className="w-full"
                src={COMMITTED_TO_SECURITY_DATA.image.jpeg}
                alt={COMMITTED_TO_SECURITY_DATA.image.alt}
                width="560"
                height="300"
                loading="lazy"
              />
            </picture>
          </div>
        }
      />
      <div className="flex py-32 pt-6 justify-between md:py-12 sm:py-12 sm:flex-col">
        <PromiseCardsSection promiseCards={DATA_SECURITY_CARDS} />
      </div>
    </section>
  );
};

export default CommittedToSecuritySection;
